import React from 'react';
import parse from 'html-react-parser';

import './style.sass';
import ScrollAnimation from '../../../../../../core/ScrollAnimation';

const CommonCircleList = ({
    CommonCircleList: { colorNumber, list },
    className = '',
    classNameInner = '',
}) => {
    return (
        <ul className={`common__circle-list ${className}`}>
            {list.map((item, index) => {
                return (
                    <ScrollAnimation
                        key={index}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <li className={`common__circle-item ${classNameInner}`}>
                            <span
                                className={`common__circle-number`}
                                style={{ background: colorNumber }}
                            ></span>
                            <span className={'common__circle-info'}>{parse(item)}</span>
                        </li>
                    </ScrollAnimation>
                );
            })}
        </ul>
    );
};

export default CommonCircleList;
